import { defineMessages } from 'react-intl'

import { MEETING_FORMATS } from '../../models/session/Session'
import { Attendance } from '../../models/user/User'
import { getStringFromMessage } from '../intl/utils/getStringFromMessage'

export const ATTENDANCE_STATUS_MESSAGES = defineMessages({
  [Attendance.ATTENDED]: {
    defaultMessage: 'Attended',
    description: 'Text describing the given user visited therapy session',
  },
  [Attendance.NO_SHOW]: {
    defaultMessage: 'No show',
    description: 'Text describing the given user did not come to therapy session',
  },
  [Attendance.LAST_MINUTE_CANCELLATION]: {
    defaultMessage: 'Last minute cancellation',
    description: 'Text describing the given user canclled appointment without proper notice',
  },
})

type SessionTypeTextItems = {
  [key: string]: string
}

export const SESSION_TYPE_MESSAGES = defineMessages({
  [MEETING_FORMATS.LIVE_MESSAGING]: {
    defaultMessage: 'Live messaging',
    description: 'Text describing a live-messaging session type',
  },
  [MEETING_FORMATS.VIDEO]: {
    defaultMessage: 'Video',
    description: 'Text describing a video session type',
  },
  [MEETING_FORMATS.IN_PERSON]: {
    defaultMessage: 'In person',
    description: 'Text describing an in-person session type',
  },
  [MEETING_FORMATS.IN_PERSON_UNDERSCORE]: {
    defaultMessage: 'In person',
    description: 'Text describing an in-person session type using the legacy meeting format',
  },
  [MEETING_FORMATS.PHONE]: {
    defaultMessage: 'Phone',
    description: 'Text describing a phone session type',
  },
  [MEETING_FORMATS.CALL]: {
    defaultMessage: 'Call',
    description: 'Text describing a call session type',
  },
  [MEETING_FORMATS.VIDEO_AND_LIVE_MESSAGING]: {
    defaultMessage: 'Video and live messaging',
    description: 'Text describing a video and live-messaging session type',
  },
  [MEETING_FORMATS.NONE_SPECIFIED]: {
    defaultMessage: 'None specified',
    description: 'Text describing a session type that has not been specified',
  },
  [MEETING_FORMATS.VIDEO_OR_IN_PERSON]: {
    defaultMessage: 'Video or in person',
    description: 'Text describing a session type that can be video or in person',
  },
})

export const SessionTypeText: SessionTypeTextItems = Object.entries(SESSION_TYPE_MESSAGES).reduce(
  (sessionTypeText, [meetingFormat, message]) => ({
    ...sessionTypeText,
    [meetingFormat]: getStringFromMessage(message) ?? meetingFormat,
  }),
  {},
)
